{
  "status": {
    "BACKLOG": "مؤجلة",
    "TODO": "للتنفيذ",
    "IN_PROGRESS": "قيد التنفيذ",
    "IN_REVIEW": "قيد المراجعة",
    "COMPLETED": "منجزة",
    "CANCELLED": "ملغاة"
  },
  "priority": {
    "LOW": "منخفضة",
    "NORMAL": "عادية",
    "HIGH": "عالية",
    "URGENT": "عاجلة"
  },
  "teamRole": {
    "LEAD": "قائد الفريق",
    "MEMBER": "عضو"
  },
  "personRole": {
    "CONTRIBUTOR": "مساهم",
    "FOLLOWER": "متابع"
  },
  "visibility": {
    "PERSONAL": "شخصية",
    "PERSONALBody": "الأشخاص المرتبطون بالمهمة فقط.",
    "TEAM": "الفريق",
    "TEAMBody": "أشخاص المهمة والفريق المسؤول كاملًا.",
    "RESTRICTED": "مقيدة",
    "RESTRICTEDBody": "أشخاص المهمة وقادة الفريق فقط.",
    "PROJECT": "المشروع",
    "PROJECTBody": "أشخاص المهمة وفريق المشروع، وأعضاء الفريق المسؤول إن وُجد.",
    "viewAllNote": "من يملك صلاحية «عرض جميع المهام» يستطيع رؤيتها دائمًا."
  },
  "due": {
    "none": "بلا تاريخ استحقاق",
    "today": "اليوم",
    "late_zero": "متأخرة",
    "late_one": "متأخرة يومًا واحدًا",
    "late_two": "متأخرة يومين",
    "late_few": "متأخرة {{n}} أيام",
    "late_many": "متأخرة {{n}} يومًا",
    "late_other": "متأخرة {{n}} يوم",
    "lateToday": "متأخرة",
    "committedWas": "الموعد الملتزم به {{date}}",
    "committedSr": "الموعد الملتزم به، وقد تغيّر:"
  },
  "blocked": {
    "label": "معطلة"
  },
  "people": {
    "inactive": "غير نشط",
    "contributors": "المساهمون",
    "followers": "المتابعون",
    "addContributor": "إضافة مساهم",
    "addFollower": "إضافة متابع",
    "remove": "إزالة {{name}}",
    "none": "لا أحد بعد",
    "unassigned": "غير مسندة",
    "teamLeadsReview": "قادة الفريق"
  },
  "progress": {
    "subtasks": "{{done}} من {{total}} مهام فرعية محسومة",
    "checklist": "{{done}} من {{total}} خطوات منجزة"
  },
  "pickers": {
    "person": "اختر شخصًا",
    "searchPeople": "ابحث عن شخص",
    "noPeople": "لا يوجد من يطابق",
    "peopleError": "تعذر تحميل الأشخاص."
  },
  "fields": {
    "number": "الرقم",
    "title": "العنوان",
    "team": "الفريق المسؤول",
    "assignee": "المسؤول عن التنفيذ",
    "reviewer": "المراجع",
    "requester": "صاحب الطلب",
    "dueDate": "تاريخ الاستحقاق",
    "dueTime": "وقت الاستحقاق",
    "customer": "العميل",
    "priority": "الأولوية",
    "type": "النوع",
    "status": "الحالة",
    "description": "الوصف",
    "expectedResult": "النتيجة المتوقعة",
    "completionNote": "ملاحظة الإنجاز",
    "plannedStart": "البدء المخطط",
    "estimate": "التقدير (بالساعات)",
    "actual": "الجهد الفعلي (بالساعات)",
    "tags": "الوسوم",
    "visibility": "من يستطيع رؤيتها",
    "review": "المراجعة",
    "committedDueDate": "تاريخ الاستحقاق الملتزم به"
  },
  "form": {
    "title": "مهمة جديدة",
    "subtaskTitle": "مهمة فرعية جديدة من {{number}}",
    "linkedTo": "مرتبطة بـ {{label}}",
    "titlePlaceholder": "ما المطلوب إنجازه، في كلمات قليلة",
    "expectedResultPlaceholder": "مثال: استيراد الأصناف، ومعالجة الصفوف المرفوضة، ومطابقة الإجماليات للملف المعتمد",
    "noTeam": "بلا فريق (مهمة شخصية)",
    "unassigned": "غير مسندة (قائمة الفريق)",
    "assignToMe": "أنا",
    "noCustomer": "بلا عميل",
    "teamLeadsReview": "قادة الفريق",
    "moreOptions": "خيارات إضافية",
    "fewerOptions": "خيارات أقل",
    "reviewRequired": "تحتاج إلى مراجعة قبل اعتبارها منجزة",
    "backlog": "لم يُلتزم بها بعد: أبقها مؤجلة",
    "required": "مطلوبة قبل إنجاز المهمة الرئيسية",
    "create": "إنشاء المهمة",
    "createSubtask": "إنشاء المهمة الفرعية",
    "hints": {
      "noTeam": "المهمة بلا فريق تكون شخصية.",
      "queue": "تنتظر في قائمة الفريق حتى يتولاها أحد.",
      "me": "المهام الشخصية لك ما لم تختر غيرك.",
      "dueTime": "اختياري. من دونه تستحق المهمة بنهاية اليوم.",
      "expectedResult": "شكل الإنجاز المطلوب. يراجع المراجع العمل وفقه.",
      "review": "يقبل شخص غير المسؤول عن التنفيذ العمل أو يعيده مع ملاحظات.",
      "reviewer": "عند عدم تحديده يستطيع أي قائد للفريق المراجعة.",
      "estimate": "بالساعات، مثل 2.5.",
      "tags": "افصل الوسوم بفواصل."
    },
    "errors": {
      "title": "اكتب عنوانًا للمهمة.",
      "dueDate": "المهمة الملتزم بها تحتاج إلى تاريخ استحقاق. أضفه، أو أبقِ المهمة مؤجلة.",
      "expectedResult": "اذكر ما سيتحقق منه المراجع.",
      "dueTimeWithoutDate": "حدد تاريخ الاستحقاق قبل الوقت.",
      "reviewerIsAssignee": "يجب أن يكون المراجع شخصًا غير المسؤول عن التنفيذ.",
      "estimate": "أدخل الساعات رقمًا، مثل 2.5."
    }
  },
  "errors": {
    "TASK_MOVE_NOT_ALLOWED": "لا يمكن نقل المهمة إلى هناك من حالتها الحالية.",
    "TASK_NOT_READY": "تنقص هذه المهمة متطلبات العمل الملتزم به: تاريخ استحقاق، ومسؤول، ونتيجة متوقعة إذا كانت تحتاج إلى مراجعة.",
    "TASK_SUBTASKS_OPEN": "أنجز المهام الفرعية المطلوبة أو ألغِها أولًا.",
    "TASK_ALREADY_CLAIMED": "تولى شخص آخر هذه المهمة قبل لحظات.",
    "TASK_CLAIM_NOT_ALLOWED": "لا يتولى هذه المهمة إلا أعضاء الفريق المسؤول.",
    "TASK_REVIEWER_IS_ASSIGNEE": "يجب أن يراجع العمل شخص غير المسؤول عن تنفيذه.",
    "TASK_NOT_PERMITTED": "لا يمكنك تنفيذ هذا الإجراء على هذه المهمة.",
    "TASK_REASON_REQUIRED": "اذكر السبب؛ يبقى في سجل المهمة.",
    "TASK_INVALID_PARENT": "تأخذ المهمة الفرعية عميل المهمة الرئيسية، ولا يمكن أن تتفرع منها مهام فرعية.",
    "TASK_INVALID_VISIBILITY": "نطاق الرؤية هذا لا يناسب المهمة: راجع فريقها ومهمتها الرئيسية.",
    "TASK_INVALID_PERSON": "اختر أشخاصًا نشطين في الشركة.",
    "TASK_INVALID_LINK": "هذا السجل غير موجود أو لا تستطيع رؤيته.",
    "TASK_CLOSED": "أعد فتح المهمة قبل تعديلها.",
    "TASK_NOT_BLOCKED": "هذه المهمة غير معطلة.",
    "TASK_ALREADY_BLOCKED": "هذه المهمة معطلة بالفعل.",
    "TEAM_ARCHIVED": "هذا الفريق مؤرشف. اختر فريقًا آخر.",
    "EXPORT_TOO_LARGE": "عدد المهام المطابقة كبير جدًا. ضيّق عوامل التصفية ثم صدّر مجددًا."
  },
  "toast": {
    "created": "تم إنشاء {{number}}",
    "moved": "أصبحت {{number}} {{status}}",
    "assigned": "تم إسناد {{number}}",
    "claimed": "توليت {{number}}",
    "blocked": "تم تعليم {{number}} معطلة",
    "unblocked": "تم رفع التعطل عن {{number}}",
    "rescheduled": "تم تغيير تاريخ الاستحقاق",
    "requested": "تم إرسال طلب تغيير التاريخ",
    "saved": "تم حفظ التغييرات",
    "commented": "تمت إضافة التعليق",
    "followed": "أصبحت تتابع {{number}}",
    "unfollowed": "توقفت عن متابعة {{number}}",
    "exported": "تم تصدير المهام",
    "personAdded": "تمت إضافة {{name}}",
    "personRemoved": "تمت إزالة {{name}}",
    "linkRemoved": "تمت إزالة الربط"
  },
  "actions": {
    "new": "مهمة جديدة",
    "export": "تصدير",
    "rowActions": "إجراءات {{number}}",
    "open": "فتح",
    "openFullPage": "فتح في صفحة كاملة",
    "moveTo": "نقل إلى…",
    "take": "تولي المهمة",
    "assign": "إسناد",
    "edit": "تعديل التفاصيل",
    "reschedule": "تغيير تاريخ الاستحقاق",
    "requestDate": "طلب تاريخ جديد",
    "block": "تعليمها معطلة",
    "unblock": "رفع التعطل",
    "follow": "متابعة",
    "unfollow": "إيقاف المتابعة",
    "history": "سجل التدقيق",
    "addSubtask": "إضافة مهمة فرعية",
    "close": "إغلاق",
    "more": "إجراءات أخرى"
  },
  "move": {
    "commit": "الالتزام بها (للتنفيذ)",
    "backlog": "تأجيلها (غير ملتزم بها)",
    "start": "بدء العمل",
    "pause": "إيقاف مؤقت (إعادة إلى للتنفيذ)",
    "submit": "تقديمها للمراجعة",
    "complete": "تعليمها منجزة",
    "accept": "قبول",
    "return": "إعادتها مع ملاحظات",
    "cancel": "إلغاء المهمة",
    "reopen": "إعادة فتح"
  },
  "moveDialog": {
    "cancelTitle": "إلغاء {{number}}؟",
    "cancelBody": "العمل الملغى لا يُحسب منجزًا. اذكر السبب؛ يبقى في السجل.",
    "reopenTitle": "إعادة فتح {{number}}؟",
    "reopenBody": "تبقى النتيجة السابقة في السجل. اذكر ما بقي من عمل.",
    "returnTitle": "إعادة {{number}} إلى المسؤول عن التنفيذ",
    "returnBody": "اذكر ما يجب تغييره. يُبلَّغ المسؤول، وتعود المهمة إلى قيد التنفيذ.",
    "submitTitle": "تقديم {{number}} للمراجعة",
    "submitBody": "يراجع المراجع العمل وفق النتيجة المتوقعة.",
    "completeTitle": "إنجاز {{number}}",
    "completeBody": "دوّن ما تم تسليمه. أرفق الإثباتات بالمهمة قبل إنجازها.",
    "reason": "السبب",
    "feedback": "ما يجب تغييره",
    "note": "ما تم تسليمه",
    "noteHint": "اختياري. يظهر في المهمة كملاحظة الإنجاز.",
    "actual": "الجهد المبذول (بالساعات)",
    "actualHint": "اختياري. يُقارن بالتقدير في التقارير.",
    "keep": "إبقاء المهمة",
    "confirm": {
      "cancel": "إلغاء المهمة",
      "reopen": "إعادة فتح المهمة",
      "return": "إعادتها إلى المسؤول",
      "submit": "تقديمها للمراجعة",
      "complete": "تعليمها منجزة"
    }
  },
  "assignDialog": {
    "title": "إسناد {{number}}",
    "body": "يتحمل الفريق المسؤولية؛ وينفذ العمل شخص واحد.",
    "queue": "إبقاؤها في قائمة الفريق",
    "notInTeam": "ليس عضوًا في الفريق.",
    "note": "ملاحظة للمسؤول عن التنفيذ",
    "save": "حفظ الإسناد"
  },
  "blockDialog": {
    "title": "تعليم {{number}} معطلة",
    "body": "يبقى الموعد كما هو. اذكر ما يعيق العمل ومن يتابعه.",
    "reason": "ما الذي يعيق العمل",
    "waitingOn": "بانتظار",
    "waitingOnHint": "شخص أو شركة أو مستند، مثل قائمة الأصناف المعتمدة من شركة ABC للتجارة.",
    "followUpOwner": "من يتابع",
    "followUpDate": "تاريخ المتابعة",
    "save": "تعليمها معطلة"
  },
  "unblockDialog": {
    "title": "رفع التعطل عن {{number}}",
    "note": "ما الذي تغيّر",
    "save": "رفع التعطل"
  },
  "rescheduleDialog": {
    "title": "تغيير تاريخ استحقاق {{number}}",
    "body": "يبقى التاريخ الملتزم به مسجلًا: تقيس التقارير التسليم وفقه.",
    "reason": "سبب تغيير التاريخ",
    "save": "تغيير تاريخ الاستحقاق"
  },
  "requestDateDialog": {
    "title": "طلب تاريخ استحقاق جديد",
    "body": "يقرر صاحب الطلب وقادة الفريق. يبقى التاريخ الحالي حتى يغيروه.",
    "proposed": "التاريخ المقترح",
    "reason": "السبب",
    "save": "إرسال الطلب"
  },
  "editSheet": {
    "title": "تعديل {{number}}",
    "save": "حفظ التغييرات"
  },
  "checklist": {
    "label": "قائمة التحقق",
    "add": "إضافة خطوة",
    "placeholder": "خطوة صغيرة من هذه المهمة",
    "remove": "إزالة الخطوة: {{text}}",
    "empty": "لا توجد خطوات بعد.",
    "removed": "أُزيلت الخطوة: {{text}}",
    "undo": "تراجع"
  },
  "links": {
    "title": "السجلات المرتبطة",
    "restricted": "سجل مقيد",
    "moduleOff": "متوقفة لشركتك؛ يبقى الربط حتى إعادة تشغيلها",
    "voided": "ملغى",
    "missing": "لم يعد موجودًا",
    "remove": "إزالة الربط مع {{label}}",
    "empty": "لا شيء. أنشئ المهام من صفحة المستند لربطها به."
  },
  "dates": {
    "created": "الإنشاء",
    "assigned": "الإسناد",
    "started": "البدء",
    "submitted": "التقديم للمراجعة",
    "completed": "الإنجاز",
    "cancelled": "الإلغاء",
    "by": "{{when}} بواسطة {{name}}"
  },
  "detail": {
    "notFound": "هذه المهمة غير موجودة أو لا تستطيع رؤيتها.",
    "youAre": {
      "ASSIGNEE": "أنت من ينفذ هذه المهمة",
      "REVIEWER": "أنت من يراجع هذه المهمة",
      "REQUESTER": "أنت من طلب هذه المهمة",
      "CONTRIBUTOR": "أنت تساهم في هذه المهمة",
      "FOLLOWER": "أنت تتابع هذه المهمة",
      "TEAM_LEAD": "أنت تقود فريقها",
      "TEAM_MEMBER": "فريقك مسؤول عن هذه المهمة",
      "OTHER": "تستطيع رؤية هذه المهمة"
    },
    "sections": {
      "description": "الوصف",
      "expectedResult": "النتيجة المتوقعة",
      "completionNote": "ملاحظة الإنجاز",
      "subtasks": "المهام الفرعية",
      "attachments": "الإثباتات والملفات",
      "activity": "النشاط",
      "people": "الأشخاص",
      "context": "السياق",
      "dates": "التواريخ",
      "effort": "الجهد"
    },
    "noDescription": "لا يوجد وصف.",
    "noExpectedResult": "لا توجد نتيجة متوقعة بعد. اذكر شكل الإنجاز المطلوب.",
    "parent": "جزء من {{number}}",
    "hiddenSubtasks": "بعض المهام الفرعية مخفية عنك بسبب نطاق رؤيتها.",
    "noSubtasks": "لا توجد مهام فرعية. قسّم العمل الذي يملكه شخص آخر إلى مهام فرعية.",
    "cancelReason": "ملغاة: {{reason}}",
    "reopened": "مرات إعادة الفتح: {{n}}",
    "returned": "مرات الإعادة من المراجع: {{n}}",
    "queueWaiting": "تنتظر في قائمة {{team}} منذ {{date}}",
    "blocker": {
      "title": "معطلة منذ {{date}}",
      "waitingOn": "بانتظار {{who}}",
      "followUp": "يتابعها {{name}} في {{date}}",
      "followUpNoDate": "يتابعها {{name}}"
    },
    "review": {
      "title": "بانتظار مراجعتك",
      "body": "راجع العمل وفق النتيجة المتوقعة، ثم اقبله أو أعده مع ما يجب تغييره."
    },
    "reviewWaiting": "مقدمة للمراجعة",
    "reviewNone": "بلا مراجعة",
    "reviewBy": "يراجعها {{name}}",
    "estimateHours": "{{h}} س",
    "estimate": "التقدير",
    "actual": "الجهد الفعلي",
    "typeLine": "النوع: {{type}}",
    "addDescription": "إضافة وصف",
    "addExpectedResult": "إضافة النتيجة المتوقعة"
  },
  "activity": {
    "title": "النشاط",
    "filter": {
      "all": "الكل",
      "comments": "التعليقات",
      "history": "السجل"
    },
    "composer": "اكتب تعليقًا",
    "composerHint": "يُبلَّغ أشخاص المهمة. Ctrl+Enter للإرسال.",
    "send": "تعليق",
    "empty": "لا شيء بعد.",
    "loadMore": "عرض الأقدم",
    "system": "النظام",
    "events": {
      "CREATED": "أنشأ المهمة",
      "UPDATED": "عدّل {{fields}}",
      "ASSIGNED": "أسندها إلى {{to}}",
      "ASSIGNED_queue": "أعادها إلى قائمة الفريق",
      "CLAIMED": "تولى المهمة",
      "TEAM_CHANGED": "غيّر الفريق",
      "MOVED": "نقلها من {{from}} إلى {{to}}",
      "REVIEW_ACCEPTED": "قبل العمل",
      "REVIEW_RETURNED": "أعاد العمل",
      "BLOCKED": "علّمها معطلة: {{reason}}",
      "UNBLOCKED": "رفع عنها التعطل",
      "DUE_CHANGED": "نقل تاريخ الاستحقاق من {{from}} إلى {{to}}",
      "DUE_SET": "حدد تاريخ الاستحقاق {{to}}",
      "DATE_REQUESTED": "طلب نقل تاريخ الاستحقاق إلى {{proposed}}: {{reason}}",
      "PRIORITY_CHANGED": "غيّر الأولوية من {{from}} إلى {{to}}",
      "PERSON_ADDED": "أضاف {{name}} بصفة {{role}}",
      "PERSON_REMOVED": "أزال {{name}}",
      "LINK_ADDED": "ربط سجلًا ({{type}})",
      "LINK_REMOVED": "أزال سجلًا مرتبطًا ({{type}})",
      "SUBTASK_ADDED": "أضاف المهمة الفرعية {{number}}",
      "REOPENED": "أعاد فتحها: {{reason}}",
      "CANCELLED": "ألغاها: {{reason}}"
    },
    "reasonLabel": "السبب: {{reason}}",
    "fieldNames": {
      "title": "العنوان",
      "description": "الوصف",
      "expectedResult": "النتيجة المتوقعة",
      "type": "النوع",
      "reviewRequired": "شرط المراجعة",
      "required": "كونها مطلوبة",
      "plannedStart": "البدء المخطط",
      "estimateMinutes": "التقدير",
      "tags": "الوسوم",
      "requesterId": "صاحب الطلب",
      "reviewerId": "المراجع",
      "customerId": "العميل",
      "visibility": "نطاق الرؤية"
    }
  },
  "myWork": {
    "title": "أعمالي",
    "intro": "ما يحتاجك اليوم، والأعمال التي طلبتها من غيرك.",
    "strip": {
      "overdue": "متأخرة",
      "dueToday": "تستحق اليوم",
      "blocked": "معطلة",
      "toReview": "للمراجعة",
      "approvals": "الموافقات",
      "queue": "قوائم الفرق",
      "approvalsOverdue_zero": "لا شيء متأخر",
      "approvalsOverdue_one": "واحدة متأخرة",
      "approvalsOverdue_two": "اثنتان متأخرتان",
      "approvalsOverdue_few": "{{n}} متأخرة",
      "approvalsOverdue_many": "{{n}} متأخرة",
      "approvalsOverdue_other": "{{n}} متأخرة"
    },
    "sections": {
      "attention": "تحتاج انتباهك",
      "assigned": "مسندة إليّ",
      "review": "للمراجعة",
      "requested": "طلبتها",
      "following": "أتابعها",
      "queue": "قوائم الفرق",
      "approvals": "موافقات بانتظارك",
      "visitsToday": "زيارات اليوم",
      "serviceDecisions": "قرارات الخدمة"
    },
    "hints": {
      "attention": "المتأخرة، والمستحقة اليوم، والعوائق التي تتابعها.",
      "queue": "أعمال غير مسندة في فرقك، الأقدم أولًا.",
      "approvals": "تُبت الموافقات في صفحة «موافقاتي» بأزرارها الخاصة: اعتماد ورفض وإعادة.",
      "visitsToday": "زيارات فرقك، الأبكر أولاً. افتح الزيارة للعمل عليها.",
      "serviceDecisions": "طلبات المتابعة المطلوب اعتمادها، والدفعات المطلوب التحقق منها، وطلباتك المعادة إليك."
    },
    "empty": {
      "attention": "لا شيء متأخر أو مستحق اليوم.",
      "assigned": "لا توجد مهام مفتوحة مسندة إليك.",
      "review": "لا شيء بانتظار مراجعتك.",
      "requested": "لا توجد طلبات مفتوحة لك.",
      "following": "لا تتابع أي مهمة مفتوحة.",
      "queue": "قوائم فرقك فارغة.",
      "approvals": "لا توجد موافقات بانتظارك.",
      "visitsToday": "لا زيارات لفرقك اليوم.",
      "serviceDecisions": "لا قرارات خدمة بانتظارك."
    },
    "openApprovals": "فتح موافقاتي",
    "showInRegister": "عرض الكل في المهام",
    "badge": "تحتاج {{n}} إلى انتباهك",
    "queuedSince": "غير مسندة منذ {{time}}",
    "openMyVisits": "فتح زياراتي",
    "visitLabel": "{{label}}، {{customer}}",
    "service": {
      "followUpsToDecide_zero": "لا طلبات متابعة للاعتماد",
      "followUpsToDecide_one": "طلب متابعة واحد للاعتماد",
      "followUpsToDecide_two": "طلبا متابعة للاعتماد",
      "followUpsToDecide_few": "{{n}} طلبات متابعة للاعتماد",
      "followUpsToDecide_many": "{{n}} طلب متابعة للاعتماد",
      "followUpsToDecide_other": "{{n}} طلب متابعة للاعتماد",
      "collectionsToVerify_zero": "لا دفعات للتحقق ({{amount}})",
      "collectionsToVerify_one": "دفعة واحدة للتحقق ({{amount}})",
      "collectionsToVerify_two": "دفعتان للتحقق ({{amount}})",
      "collectionsToVerify_few": "{{n}} دفعات للتحقق ({{amount}})",
      "collectionsToVerify_many": "{{n}} دفعة للتحقق ({{amount}})",
      "collectionsToVerify_other": "{{n}} دفعة للتحقق ({{amount}})",
      "returned": "أُعيد طلب المتابعة على {{label}} · {{customer}}"
    },
    "moreInRegister_zero": "لا مزيد",
    "moreInRegister_one": "مهمة أخرى في المهام",
    "moreInRegister_two": "مهمتان أخريان في المهام",
    "moreInRegister_few": "{{n}} مهام أخرى في المهام",
    "moreInRegister_many": "{{n}} مهمة أخرى في المهام",
    "moreInRegister_other": "{{n}} مهمة أخرى في المهام"
  },
  "list": {
    "title": "المهام",
    "views": "عروض المهام",
    "view": {
      "open": "المفتوحة",
      "mine": "مهامي",
      "unassigned": "غير المسندة",
      "overdue": "المتأخرة",
      "blocked": "المعطلة",
      "review": "للمراجعة",
      "completed": "المنجزة",
      "cancelled": "الملغاة",
      "all": "الكل"
    },
    "layout": {
      "label": "طريقة العرض",
      "list": "قائمة",
      "board": "لوحة",
      "calendar": "التقويم"
    },
    "searchPlaceholder": "الرقم أو العنوان أو العميل أو الشخص",
    "searchLabel": "البحث في المهام",
    "clearSearch": "مسح البحث",
    "tableLabel": "المهام",
    "clearFilters": "مسح عوامل التصفية",
    "filters": {
      "team": "الفريق",
      "allTeams": "كل الفرق",
      "assignee": "المسؤول",
      "anyone": "أي شخص",
      "me": "أنا",
      "nobody": "غير مسندة",
      "priority": "الأولوية",
      "anyPriority": "أي أولوية",
      "due": "الاستحقاق",
      "anyDue": "أي تاريخ استحقاق",
      "dueOptions": {
        "overdue": "متأخرة",
        "today": "تستحق اليوم",
        "week": "الأيام السبعة القادمة",
        "later": "لاحقًا",
        "none": "بلا تاريخ استحقاق"
      },
      "active": "تصفية حسب: {{filters}}",
      "customer": "العميل",
      "drill": {
        "stale": "بلا تحديث منذ 7 أيام",
        "inactiveAssignee": "مسؤول غير نشط",
        "late": "أُنجزت متأخرة",
        "reworked": "أُعيدت أو أُعيد فتحها",
        "following": "أتابعها",
        "blocked": "معطلة",
        "myBlocked": "معطلة: المسندة إليّ أو التي أتابع عوائقها",
        "completedRange": "أُنجزت {{from}} – {{to}}",
        "dueRange": "تستحق {{from}} – {{to}}",
        "tag": "الوسم {{tag}}",
        "requester": "طلبتها",
        "reviewer": "المراجع",
        "status": "الحالة {{status}}",
        "type": "النوع {{type}}",
        "onTime": "أُنجزت في موعدها",
        "committedRange": "الموعد الملتزم به {{from}} – {{to}}",
        "deliverable": "بلا مهام فرعية",
        "hasCustomer": "أعمال العملاء",
        "noCustomer": "أعمال داخلية"
      }
    },
    "empty": {
      "title": "لا توجد مهام بعد",
      "body": "أنشئ مهمة، أو ابدأها من صفحة عميل أو مستند.",
      "filteredTitle": "لا توجد مهام مطابقة",
      "filteredBody": "جرّب عوامل تصفية أخرى أو امسحها.",
      "view": "لا توجد مهام في هذا العرض."
    }
  },
  "columns": {
    "number": "الرقم",
    "title": "العنوان",
    "customer": "العميل",
    "team": "الفريق",
    "assignee": "المسؤول عن التنفيذ",
    "status": "الحالة",
    "priority": "الأولوية",
    "due": "الاستحقاق",
    "progress": "التقدم",
    "updated": "آخر تحديث"
  },
  "board": {
    "label": "لوحة المهام",
    "column": "عمود {{status}}",
    "empty": "لا مهام",
    "more": "عرض أول {{shown}} من {{total}}",
    "completedRecent": "المنجزة خلال آخر 14 يومًا",
    "moving": "جارٍ نقل {{number}}…",
    "dragHint": "اسحب البطاقة إلى عمود آخر، أو استخدم قائمة «نقل إلى…».",
    "refused": "بقيت {{number}} في {{status}}: {{reason}}"
  },
  "related": {
    "title": "المهام",
    "new": "مهمة جديدة",
    "empty": "لا توجد مهام بعد.",
    "emptyBody": "أنشئ مهمة لمتابعة هذا السجل.",
    "counts": {
      "open": "مفتوحة",
      "overdue": "متأخرة",
      "blocked": "معطلة",
      "completed": "منجزة"
    },
    "showAll": "عرض الكل في المهام",
    "unavailable": "تعذر تحميل المهام."
  },
  "calendar": {
    "title": "التقويم",
    "intro": "مواعيد الاستحقاق والأعمال المجدولة.",
    "previousMonth": "الشهر السابق",
    "nextMonth": "الشهر التالي",
    "previousWeek": "الأسبوع السابق",
    "nextWeek": "الأسبوع التالي",
    "today": "اليوم",
    "mode": {
      "label": "عرض التقويم",
      "month": "شهر",
      "week": "أسبوع"
    },
    "scope": {
      "label": "عرض",
      "all": "المفتوحة والمنجزة",
      "open": "المفتوحة فقط"
    },
    "starts": "إظهار مواعيد البدء المخططة",
    "startsPrefix": "تبدأ",
    "more": "+{{n}} أخرى",
    "newOnDay": "مهمة جديدة في {{date}}",
    "gridLabel": "المهام حسب اليوم",
    "dayLabel": "{{date}}",
    "chipLabel": "{{number}} {{title}}، {{status}}",
    "chipStartsLabel": "تبدأ {{number}} {{title}}",
    "weekRange": "{{from}} – {{to}}",
    "unscheduled": {
      "title": "غير مجدولة",
      "hint": "أعمال مفتوحة بلا تاريخ استحقاق. اسحب إحداها إلى يوم لجدولتها.",
      "empty": "لكل الأعمال المفتوحة تاريخ استحقاق.",
      "showAll": "عرض الكل في المهام",
      "hintTouch": "أعمال مفتوحة بلا تاريخ استحقاق. افتح إحداها وحدد تاريخ استحقاقها.",
      "failed": "تعذر تحميل الأعمال غير المجدولة."
    },
    "truncated": "تظهر أول 1,000 مهمة فقط في هذه الفترة. ضيّق عوامل التصفية لرؤية الباقي.",
    "agendaEmpty": "لا توجد مهام في هذه الفترة.",
    "keyboardHint": "من دون فأرة: افتح المهمة واستخدم «تغيير تاريخ الاستحقاق».",
    "visits": "إظهار زياراتي",
    "visitChipLabel": "زيارة {{label}}، {{customer}}، {{window}}",
    "visitsUnavailable": "تعذّر تحميل زياراتك.",
    "introTouch": "مواعيد الاستحقاق والأعمال المجدولة. لنقل مهمة إلى يوم آخر افتحها واستخدم «تغيير تاريخ الاستحقاق».",
    "holiday": "عطلة:",
    "holidayProvisional": "{{name}} (غير مؤكدة)",
    "dragHint": "اسحب المهمة إلى يوم آخر لتغيير تاريخ استحقاقها: تؤكد التغيير ويُسجَّل."
  }
}
